import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Form, DropdownProps, Label, Popup, Statistic, Segment } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";

import NumberFormat from "../../Utils/NumberFormat";
import errors from "../../Utils/ExtractErrors";
import PartialSectorRepository, { IPartialMonthSector, IPartialMonthSectorParams } from "../../Repositories/PartialReportSectorRepository";
import CustomLoader from "../../components/CustomLoader";


const PartialMonthSector: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IPartialMonthSector[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IPartialMonthSectorParams>({
        year: date.getFullYear().toString(),
        month: (date.getMonth() + 1).toString(),
        agentId: "",
        tipo: "0,1",
        comVendas: "AMBOS"
    });
    const [agents, setAgents] = useState<IAgentListModel[]>([]);

    const totalFaltam = list.reduce((a, b) => b.faltam, 0);
    const totalConferidos = list.reduce((a, b) => a + b.quantidade, 0);
    const totalBruto = list.reduce((a, b) => a + b.totalVendas, 0);
    const comissaoRevs = (list.reduce((a, b) => a + b.totalVendas, 0) - list.reduce((a, b) => a + b.totalReceber, 0));
    const comissaoReps = (list.reduce((a, b) => a + b.totalRecebido, 0) - list.reduce((a, b) => a + b.empresa, 0));
    const totalComissoes = comissaoRevs + comissaoReps;
    const totalEntradas = list.reduce((a, b) => a + b.empresa, 0);
    const totalDebitos = (list.reduce((a, b) => a - b.credDeb, 0) * 0.80);

    const setQtd = (quantidade: number) => {
        return <Popup
            hoverable
            wide
            trigger={
                <Label ribbon color="blue">
                    {quantidade}
                </Label>
            }
        />
    }

    const setDebito = (credDeb: number) => {
        if (credDeb < 0) {
            return <Label color="red" size="large" content={NumberFormat.Currency(credDeb)} />
        } else {
            return NumberFormat.Currency(credDeb);
        }
    }
    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const optionsType = [
        { key: "1", text: "AMBOS", value: "0,1" },
        { key: "2", text: "NOVO", value: "0" },
        { key: "3", text: "ACERTO", value: "1" }
    ];

    const optionsVendas = [
        { key: "1", text: "AMBOS", value: "AMBOS" },
        { key: "2", text: "COM VENDAS", value: "> 0" },
        { key: "3", text: "SEM VENDAS", value: "= 0" }
    ];

    const load = async () => {

        setLoading(true);
        try {

            const response = await PartialSectorRepository.PartialMonthSector({
                year: state.year,
                month: state.month,
                agentId: state.agentId,
                tipo: state.tipo,
                comVendas: state.comVendas
            });

            setList(response);
            LoadAgents("");
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    useEffect(() => { load() }, []);

    const LoadAgents = useCallback(async (id: string) => {
        const result = await AgentsRepository.List({
            filter: `Status == 1`
        });

        setAgents(result.list);
    }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Qtd",
            content: (x: IPartialMonthSector) => setQtd(x.quantidade),
            textAlign: "left",
            width: 1
        },
        {
            header: "Representante",
            content: (x: IPartialMonthSector) => x.representante,
            textAlign: "left",
            width: 5
        },
        {
            header: "R$ Bruto",
            content: (x: IPartialMonthSector) => NumberFormat.Currency(x.totalVendas),
            textAlign: "left",
            width: 2
        },
        {
            header: "R$ Receber",
            content: (x: IPartialMonthSector) => NumberFormat.Currency(x.totalReceber),
            textAlign: "left",
            width: 2
        },
        {
            header: "R$ Recebido",
            content: (x: IPartialMonthSector) => NumberFormat.Currency(x.totalRecebido),
            textAlign: "left",
            width: 2
        },
        {
            header: "R$ Cred/Deb",
            content: (x: IPartialMonthSector) => setDebito(x.credDeb),
            textAlign: "left",
            width: 2
        },
        {
            header: "R$ Empresa",
            content: (x: IPartialMonthSector) => NumberFormat.Currency(x.empresa),
            textAlign: "left",
            width: 2
        },
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content="Entradas" icon="dollar" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Statistic.Group size="tiny" widths="6">
                                    <Statistic color="blue">
                                        <Statistic.Value>{totalConferidos}</Statistic.Value>
                                        <Statistic.Label content="Kits Conferidos"></Statistic.Label>
                                    </Statistic>
                                    <Statistic color="orange">
                                        <Statistic.Value>{totalFaltam}</Statistic.Value>
                                        <Statistic.Label content="Faltam Conferir"></Statistic.Label>
                                    </Statistic>
                                    <Statistic color="grey">
                                        <Statistic.Value>{NumberFormat.Currency(totalBruto)}</Statistic.Value>
                                        <Statistic.Label content="Total Bruto"></Statistic.Label>
                                    </Statistic>
                                    <Statistic color="teal">
                                        <Statistic.Value>{NumberFormat.Currency(totalComissoes)}</Statistic.Value>
                                        <Statistic.Label content="Total Comissões"></Statistic.Label>
                                    </Statistic>
                                    <Statistic color="green">
                                        <Statistic.Value>{NumberFormat.Currency(totalEntradas)}</Statistic.Value>
                                        <Statistic.Label content="Total Entradas"></Statistic.Label>
                                    </Statistic>
                                    <Statistic color="red">
                                        <Statistic.Value>{NumberFormat.Currency(totalDebitos)}</Statistic.Value>
                                        <Statistic.Label content="Total Débitos"></Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}

                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="tipo"
                                                placeholder="Tipo"
                                                label="Tipo"
                                                options={optionsType}
                                                value={state.tipo}
                                                onChange={onDropdownChange}
                                                required
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="comVendas"
                                                placeholder="Selecione"
                                                label="Com Vendas"
                                                options={optionsVendas}
                                                value={state.comVendas}
                                                onChange={onDropdownChange}
                                                required
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="agentId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="Representante"
                                                onChange={onDropdownChange}
                                                options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                                value={state.agentId}
                                                clearable
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Pesquisar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default PartialMonthSector;
